<ul>
    <!-- <li><a href="#home/home">Home</a></li> -->
    <li><a href="#home/impressum">Impressum</a></li>
    <li><a href="#home/datenschutz">Datenschutzerklärung</a></li>
</ul>